/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-useless-escape */
import Alert from 'components/Alert'
import Button from 'components/Button/Button'
import { Input } from 'components/Input'
import Spinner from 'components/Spinner'
import { Text } from 'components/Text'
import { useEncrypt } from 'hooks/useEncrypt'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { useAppDispatch, useAppState } from 'store'
import { authActions } from 'store/slices/auth'
import { SignUpContainer, SignUpItem } from './SignUp.styled'

export const validateEmail = (email: string) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
}

const SignUp: React.FC = () => {
  const dispatch = useAppDispatch()
  const { push } = useHistory()
  const { encryptPhrase } = useEncrypt()
  const { authStatus } = useAppState(state => state.auth)
  const [invalidEmail, setInvalidEmail] = useState<boolean>(false)
  const [firstName, setFirstName] = useState<string | null>(null)
  const [lastName, setLastName] = useState<string | null>(null)
  const [email, setEmail] = useState<string | null>(null)
  const [passwordError, setPasswordError] = useState<string | null>(null)
  const [password, setPassword] = useState<string | null>(null)
  const [confirmPassword, setConfirmPassword] = useState<string | null>(null)
  const [confirmPasswordError, setConfirmPasswordError] = useState<
    string | null
  >(null)
  const [isDisabled, setIsDisabled] = useState<boolean>(true)

  useEffect(() => {
    if (
      firstName &&
      lastName &&
      email &&
      confirmPassword &&
      !confirmPasswordError &&
      !invalidEmail
    ) {
      setIsDisabled(false)
      return
    } else {
      setIsDisabled(true)
      return
    }
  }, [
    firstName,
    lastName,
    email,
    confirmPassword,
    confirmPasswordError,
    invalidEmail,
  ])

  const handleEmail = (value: string) => {
    const isValid = validateEmail(value)
    if (!isValid) {
      setInvalidEmail(true)
      setEmail(null)
      return
    } else {
      setInvalidEmail(false)
      setEmail(value)
    }
  }

  const validatePassword = (value: string, type: 'confirmation' | 'new') => {
    if (type === 'new') {
      if (value.length < 8) {
        setPasswordError('8 characters minimum')
        setPassword(null)
        return
      } else {
        setPasswordError(null)
        setPassword(value)
        return
      }
    } else {
      if (value.length < 8) {
        setConfirmPasswordError('8 characters minimum')
        setConfirmPassword(null)
        return
      }
      if (value === password) {
        setConfirmPasswordError(null)
        setConfirmPassword(value)
        return
      } else {
        setConfirmPasswordError('Passwords do not match')
        setConfirmPassword(null)
        return
      }
    }
  }

  const handleSubmit = async () => {
    if (email && password && lastName && firstName) {
      const encryption = encryptPhrase(password)
      await dispatch(
        authActions.signUp({
          firstName,
          lastName,
          email,
          password: encryption,
        })
      ).then((res: any) => {
        if (!res.payload.error) {
          push('/profile')
        }
      })
    }
  }

  return (
    <SignUpContainer>
      {authStatus === 'loading' ? (
        <Spinner />
      ) : (
        <>
          <Text text="Sign Up" color="fontSecondary" preset="h3" weight="700" />
          <SignUpItem>
            <Input
              label={'First Name'}
              required
              style={{ width: 320 }}
              onTextChange={setFirstName}
            />
          </SignUpItem>
          <SignUpItem>
            <Input
              label={'last Name'}
              required
              style={{ width: 320 }}
              onTextChange={setLastName}
            />
          </SignUpItem>
          <SignUpItem>
            <Input
              label={'Email'}
              required
              style={{ width: 320 }}
              onTextChange={handleEmail}
            />
            {invalidEmail && (
              <Alert type="danger" msg="Please enter a valid email address" />
            )}
          </SignUpItem>
          <SignUpItem>
            <Input
              label={'Password'}
              type="password"
              required
              style={{ width: 320 }}
              onTextChange={text => validatePassword(text, 'new')}
            />
            {passwordError && <Alert type="danger" msg={passwordError} />}
          </SignUpItem>
          <SignUpItem>
            <Input
              label={'Confirm Password'}
              type="password"
              required
              style={{ width: 320 }}
              onTextChange={text => validatePassword(text, 'confirmation')}
            />
            {confirmPasswordError && (
              <Alert type="danger" msg={confirmPasswordError} />
            )}
          </SignUpItem>
          <SignUpItem>
            <Button
              text="Submit"
              variant="primary"
              preset="filled"
              size={'medium'}
              disabled={isDisabled}
              onClick={handleSubmit}
            />
          </SignUpItem>
        </>
      )}
    </SignUpContainer>
  )
}

export default SignUp
